import React, {useCallback, useState} from 'react';
import {useTranslation} from 'react-i18next';

import {IconBell, NotificationBadge, NotificationCenter} from '@veneer/core';

import useClickOutside from '../../hooks/useClickOutside';
import {useNotifications} from '../../storages';
import {WFCButton} from '../WFCButton';

import useStyles from './styles';

const Notifications = (): JSX.Element => {
    const {t} = useTranslation(['Notifications']);
    const {notifications} = useNotifications();

    const styles = useStyles();

    const [open, setOpen] = useState(false);

    const handleToggle = useCallback(() => {
        setOpen(curr => !curr);
    }, []);

    const ref = useClickOutside<HTMLDivElement>(() => {
        setOpen(false);
    });

    let button = (
        <WFCButton
            customStyle={{position: 'relative'}}
            onClick={handleToggle}
            aria-label={t('Notifications:optionNotificationCenter', 'Open Notification Center')}
            data-count={notifications.length}
            data-open={open}
            leadingIcon={<IconBell aria-hidden />}
            small
        />
    );

    if (notifications.length > 0) {
        button = <NotificationBadge>{button}</NotificationBadge>;
    }

    return (
        <div
            className={styles.wrapper}
            ref={ref}
        >
            {button}
            {open && (
                <div
                    className={styles.notificationCenter}
                    role="dialog"
                >
                    <NotificationCenter
                        id="notifications"
                        data-testid="notification-center"
                        items={notifications}
                        placement="bottom-end"
                        i18n={{
                            actionButton: t('Notifications:actionButton', 'Action button'),
                            noNotifications: t('Notifications:noNotifications', 'There are no notifications.'),
                            title: t('Notifications:title', 'Notifications'),
                        }}
                        inline
                    />
                </div>
            )}
        </div>
    );
};

export default Notifications;
